import { FC, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import cn from 'classnames'

import { ReactComponent as ArrowDown } from '@src/assets/arrow_down.svg'
import style from '@src/components/Tablist/TabList.module.scss'

type TabListProps = {
  options: Array<{
    url: string
    title: string
  }>
  className?: string
}

export const TabList: FC<TabListProps> = ({ className, options }) => {
  const [mobileMenu, setMobileMenu] = useState(false)
  const location = useLocation()

  return (
    <div className={cn(style.wrapperMenu, className)}>
      <ul className={style.desktop}>
        {options.map((item) => (
          <li key={item.url}>
            <NavLink
              to={item.url}
              className={`${style.btn}`}
              activeClassName={style.active}
            >
              {item.title}
            </NavLink>
          </li>
        ))}
      </ul>
      <div id="custom_tabs" className={style.mobile}>
        <div className={style.wrapper}>
          <div
            tabIndex={0}
            role="button"
            className={cn(style.accordion, mobileMenu && style.active)}
            onClick={() => setMobileMenu(!mobileMenu)}
            onKeyDown={() => setMobileMenu(!mobileMenu)}
          >
            <div>
              {options.find((item) => item.url === location.pathname)?.title}
              <ArrowDown className={style.svg} />
            </div>
          </div>
          <div className={cn(style.panel, mobileMenu && style.active)}>
            <ul>
              {options.map((item) => (
                <li
                  key={item.url}
                  onClick={() => setMobileMenu(!mobileMenu)}
                  onKeyPress={() => setMobileMenu(!mobileMenu)}
                  role="menuitem"
                  tabIndex={0}
                >
                  <NavLink
                    to={item.url}
                    className={`${style.btn}`}
                    activeClassName={style.active}
                  >
                    {item.title}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
